import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles.scss';
import { App as AntdApp } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AntdApp>
    <App />
  </AntdApp>
);

reportWebVitals();
